// extracted by mini-css-extract-plugin
export default {"applicant-button":"style_applicant-button__67f+w","priority":"style_priority__62tA0"};